import {
  PersonOutlineOutlined as PersonOutlineOutlinedIcon,
  Person as PersonIcon,
  Timelapse as TimelapseIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  NotificationImportant as NotificationImportantIcon,
  DeleteForever as DeleteForeverIcon,
  Help as HelpIcon,
} from '@mui/icons-material_modern'

export const UUIDRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i

export const ADJUSTMENT_TYPES = {
  COST: 'cost',
  WEIGHT: 'weight',
}

export const ADJUSTMENT_TYPES_ARRAY = [
  {
    id: ADJUSTMENT_TYPES.COST,
    name: 'Cost',
    value: ADJUSTMENT_TYPES.COST,
    label: 'Cost',
  },
  {
    id: ADJUSTMENT_TYPES.WEIGHT,
    name: 'Weight',
    value: ADJUSTMENT_TYPES.WEIGHT,
    label: 'Weight',
  },
]

export const MEASURE_UNIT = {
  POUND: 'lbs',
  GROSS_TONS: 'gt',
  NET_TONS: 'nt',
  METRIC_TONS: 'mt',
  EACH: 'ea',
  HUNDRED_WEIGHT: 'cwt',
  KILOGRAM: 'kg',
}

export const MEASURE_UNIT_ARRAY = Object.values(MEASURE_UNIT).map(value => ({
  id: value,
  name: value.toUpperCase(),
  label: value.toUpperCase(),
  value,
}))

export const UNIT_IDS = {
  POUND: 'pound',
  USD: 'usd',
  PERCENTAGE: 'percentage',
}

export const UNITS_ARRAY = [
  {
    id: UNIT_IDS.POUND,
    name: 'lbs',
    value: UNIT_IDS.POUND,
    label: 'lbs',
  },
  {
    id: UNIT_IDS.USD,
    name: '$',
    value: UNIT_IDS.USD,
    label: '$',
  },
  {
    id: UNIT_IDS.PERCENTAGE,
    name: '%',
    value: UNIT_IDS.PERCENTAGE,
    label: '%',
  },
]

export const TICKET_STATUSES = {
  INCOMPLETE: {
    id: 'INCOMPLETE',
    name: 'Incomplete',
  },
  SCALE_COMPLETE: {
    id: 'SCALE_COMPLETE',
    name: 'Scale Complete',
  },
  PRICE_COMPLETE: {
    id: 'PRICE_COMPLETE',
    name: 'Price Complete',
  },
  APPROVED: {
    id: 'APPROVED',
    name: 'Approved',
  },
  VOIDED: {
    id: 'VOIDED',
    name: 'Voided',
  },
  AVAILABLE: {
    id: 'AVAILABLE',
    name: 'Available',
  },
  SHIPPED: {
    id: 'SHIPPED',
    name: 'Shipped',
  },
  VOID: {
    id: 'VOID',
    name: 'Void',
  },
  PAID: {
    id: 'PAID',
    name: 'Paid',
  },
  TRUCK_IN_YARD: {
    id: 'TRUCK_IN_YARD',
    name: 'Truck In Yard',
  },
}

export const OUTBOUND_TICKET_STATUSES = {
  INCOMPLETE: {
    id: 'INCOMPLETE',
    name: 'Incomplete',
  },
  SHIPPED: {
    id: 'SHIPPED',
    name: 'Shipped',
  },
  AVAILABLE: {
    id: 'AVAILABLE',
    name: 'Available',
  },
  VOID: {
    id: 'VOID',
    name: 'Void',
  },
  INVOICED: {
    id: 'INVOICED',
    name: 'Invoiced',
  },
  PAID: {
    id: 'PAID',
    name: 'Paid',
  },
}

export const PAYMENT_STATUSES = {
  OPEN: {
    id: 'Open',
    name: 'Open',
  },
  CLOSED: {
    id: 'Closed',
    name: 'Closed',
  },
  PAID: {
    id: 'Paid',
    name: 'Complete',
  },
  VOID: {
    id: 'Void',
    name: 'Void',
  },
}

export const BILL_STATUSES = {
  PARTIAL: {
    id: 'PARTIAL',
    name: 'Partial',
  },
  PAID: {
    id: 'PAID',
    name: 'Paid',
  },
  DUE: {
    id: 'DUE',
    name: 'Due',
  },
  VOID: {
    id: 'VOID',
    name: 'Void',
  },
  SAVING: {
    id: 'SAVING',
    name: 'Saving',
  },
  INVOICED: {
    id: 'INVOICED',
    name: 'Invoiced',
  },
}

export const COMMON_STATUSES = {
  AVAILABLE: {
    id: 'AVAILABLE',
    name: 'AVAILABLE',
  },
  UNAVAILABLE: {
    id: 'UNAVAILABLE',
    name: 'UNAVAILABLE',
  },
  VOID: {
    id: 'VOID',
    name: 'VOID',
  },
  ALL: {
    id: 'ALL',
    name: 'ALL',
  },
  SHIPPED: {
    id: 'SHIPPED',
    name: 'Shipped',
  },
}

export const TEST_USER_ID = 'tester'

export const ID_TYPES = {
  LICENSE: {
    id: 'license',
    name: 'Driver’s license',
  },
}

export const GENDERS = {
  M: {
    id: 'M',
    name: 'M',
  },
  F: {
    id: 'F',
    name: 'F',
  },
  O: {
    id: 'O',
    name: 'O',
  },
}

export const DEFAULT_SUPPLIER_TYPES = {
  INDUSTRIAL: 'Industrial',
  RETAIL: 'Retail',
}

export const LOCATION_TYPES = {
  CORPORATE: {
    id: 'corporate',
    name: 'Corporate',
  },
  SHIPPING: {
    id: 'shipping',
    name: 'Shipping',
  },
  PAY_TO: {
    id: 'pay_to',
    name: 'Pay To',
  },
}

export const ACCOUNT_TYPES = {
  SUPPLIER: {
    id: 'supplier',
    name: 'Supplier',
  },
  CONSUMER: {
    id: 'consumer',
    name: 'Consumer',
  },
  SUPPLIERANDCONSUMER: {
    id: 'supplierAndConsumer',
    name: 'Supplier & Consumer',
  },
  CARRIER: {
    id: 'carrier',
    name: 'Carrier',
  },
}

export const MIN_VEHICLE_YEAR = 1908

export const PACKAGE_OPTIONS = [
  { id: 'bale', name: 'Bale' },
  { id: 'box', name: 'Box' },
  { id: 'package', name: 'Package' },
  { id: 'sows', name: 'Sows' },
  { id: 'mixed', name: 'Mixed' },
  { id: 'loose', name: 'Loose' },
]

export const WEIGHT_OPTIONS = [
  { id: 'yard', name: 'Yard' },
  { id: 'consumer', name: 'Consumer' },
]

export const PICKUP_OPTIONS = [
  { id: 'pickup', name: 'Pickup' },
  { id: 'delivery', name: 'Delivery' },
]

export const ALL_PAYMENT_METHOD_OPTIONS = [
  { id: 'cash', name: 'Cash' },
  { id: 'check', name: 'Check' },
  { id: 'eft', name: 'EFT' },
  { id: 'atm', name: 'ATM' },
  { id: 'gs_pay', name: 'GreenSpark Pay' },
]

export const DOCUMENT_TYPE_MAP = {
  IBT_PURCHASE_TICKET: 'Purchase Ticket',
  IBT_SCALE_TICKET: 'Scale Ticket',
  BILL_SETTLEMENT_DOC: 'Bill Settlement Document',
  OBT_PACKING_LIST: 'Packing List',
  OBT_BILL_OF_LADING: 'Bill Of Lading',
  INVOICE: 'Invoice',
}

export const DOCUMENT_TYPE_ARRAY = Object.keys(DOCUMENT_TYPE_MAP).map(key => ({
  id: key,
  name: DOCUMENT_TYPE_MAP[key],
}))

// commented fields will be added back when backend issues are addressed
export const INBOUND_TICKET_FIELD_MAP = {
  TRUCK_NUMBER: {
    id: 'truckNumber',
    name: 'Truck #',
  },
  NOTES: {
    id: 'notes',
    name: 'Notes',
  },
  CONTACT: {
    id: 'contact',
    name: 'Contact',
  },
  LOCATION: {
    id: 'location.name',
    name: 'Location',
  },
  NUMBER_OF_PASSENGERS: {
    id: 'numberOfPassengers',
    name: 'Number of Passengers',
  },
  LICENSE_PLATE_NUMBER: {
    id: 'vehicle.plateNumber',
    name: 'License Plate #',
  },
  MAKE: {
    id: 'vehicle.make',
    name: 'Make',
  },
  MODEL: {
    id: 'vehicle.model',
    name: 'Model',
  },
  PICKUP: {
    id: 'transportationInfo.isPickup',
    name: 'Pickup',
  },
  PURCHASE_ORDER_NUMBER: {
    id: 'transportationInfo.purchaseOrderNumber',
    name: 'Purchase Order #',
  },
  // DISPATCH_TICKET: {
  //   id: 'linkedDispatchTicket.externalId',
  //   name: 'Dispatch Ticket',
  // },
  BILL_OF_LADING: {
    id: 'billOfLading',
    name: 'Bill of Lading',
  },
  DRIVER_NAME: {
    id: 'transportationInfo.driverName',
    name: 'Driver Name',
  },
  TRAILER_NUMBER: {
    id: 'transportationInfo.trailerNumber',
    name: 'Trailer #',
  },
  CONTAINER_NUMBER: {
    id: 'transportationInfo.containerNumber',
    name: 'Container #',
  },
}

export const INBOUND_TICKET_FIELD_ARRAY = Object.keys(INBOUND_TICKET_FIELD_MAP).map(key => ({
  id: INBOUND_TICKET_FIELD_MAP[key].id,
  name: INBOUND_TICKET_FIELD_MAP[key].name,
}))

export const CASH_DRAWER_PAYMENT_METHOD = 'other cash drawer activity'

export const PAYMENT_METHODS_VALUES = {
  CASH: 'Cash',
  CHECK: 'Check',
  EFT: 'EFT',
  ATM: 'ATM',
  GS_PAY: 'GreenSpark Pay',
  MULTIPLE: 'Multiple',
}

export const ACCOUNT_PAYMENT_TYPE_ENUMS = {
  CASH: 'CASH',
  CHECKING: 'CHECKING',
  EFT: 'EFT',
  ATM: 'ATM',
}

export const MATERIAL_TYPE_RULES = {
  PAYMENT_HOLD: 'PAYMENT_HOLD',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
}

export const ACCOUNT_PAYMENT_TYPES = [
  { id: ACCOUNT_PAYMENT_TYPE_ENUMS.CASH, name: 'Cash' },
  { id: ACCOUNT_PAYMENT_TYPE_ENUMS.CHECKING, name: 'Check' },
  { id: ACCOUNT_PAYMENT_TYPE_ENUMS.EFT, name: 'EFT' },
  { id: ACCOUNT_PAYMENT_TYPE_ENUMS.ATM, name: 'ATM' },
]

export const PAYMENT_OPTIONS_OPTIONS = [
  { id: 'perLoad', name: 'Per Load' },
  { id: 'endOfMonth', name: 'End of Month' },
  { id: 'atExpiry', name: 'At Expiry' },
]
export enum CURRENCY_ENUM {
  CAD = 'CAD',
  USD = 'USD',
  NZD = 'NZD',
}

export const CURRENCY_OPTIONS = [
  { id: 'CAD', name: CURRENCY_ENUM.CAD },
  { id: 'USD', name: CURRENCY_ENUM.USD },
  { id: 'NZD', name: CURRENCY_ENUM.NZD },
]

export const CURRENCY_PREPENDS = {
  CAD: {
    hc: '$',
    fc: 'CA$',
  },
  USD: {
    hc: '$',
    fc: 'US$',
  },
  NZD: {
    hc: '$',
    fc: 'NZ$',
  },
}

export const PURCHASE_ORDER_DROPDOWN_VALUES = {
  PACKAGE_OPTIONS,
  PICKUP_OPTIONS,
  ALL_PAYMENT_METHOD_OPTIONS,
  PAYMENT_OPTIONS_OPTIONS,
  CURRENCY_OPTIONS,
}

export const SALES_ORDER_DROPDOWN_VALUES = {
  PACKAGE_OPTIONS,
  WEIGHT_OPTIONS,
  ALL_PAYMENT_METHOD_OPTIONS,
  PAYMENT_OPTIONS_OPTIONS,
  CURRENCY_OPTIONS,
}

export const CONTRACT_STATUSES = {
  OPEN: {
    id: 'OPEN',
    name: 'Open',
  },
  CLOSED: {
    id: 'CLOSED',
    name: 'Closed',
  },
}

export const ORDER_STATUSES = [
  { id: 'Open', name: 'Open' },
  { id: 'Closed', name: 'Closed' },
]

export const INVOICE_STATUSES = {
  OPEN: { id: 'OPEN', name: 'Open' },
  PAID: { id: 'PAID', name: 'Paid' },
  VOID: { id: 'VOID', name: 'Void' },
  CLOSED: { id: 'CLOSED', name: 'Closed' },
}

export const PRICE_TYPES = {
  FORMULA: {
    id: 'FORMULA',
    name: 'FORMULA',
  },
  SPOT: {
    id: 'SPOT',
    name: 'SPOT',
  },
}

export const PRICE_SHEET_TYPES = {
  DEFAULT: 'DEFAULT',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  SALES_ORDER: 'SALES_ORDER',
  PRICE_LIST: 'PRICE_LIST',
}

export const BILL_ACTION = {
  SAVE: 0,
  VOID: 1,
  PAY: 2,
}

export const IBT_VIEW_OPTIONS = {
  INDUSTRIAL: 'industrial',
  SCALE: 'scale',
}

export const IBT_LIBRARY_VIEW_OPTIONS = {
  LIST: 'list',
  GRID: 'grid',
}

export const IBT_ROW_TYPES = {
  MATERIAL: 'material',
  LOAD_TOTAL: 'load-total',
  TRUCK_TOTAL: 'truck-total',
  SCRAP_VEHICLE: 'scrap-vehicle',
  DIFFERENTIAL: 'differential',
  FREIGHT_CHARGEBACK: 'freight-chargeback',
  FEE: 'fee',
  PROMOTION: 'promotion',
}

export const FEE_OR_PROMOTION_TYPE = {
  FEE: 'FEE',
  PROMOTION: 'PROMOTION',
}

export const SCALE_MATERIAL_VIEW_OPTIONS = {
  BUTTONS: 'buttons',
  MATERIAL_ENTRY_NEW: 'material_entry_new',
  MATERIAL_ENTRY_UPDATE: 'material_entry_update',
  TRUCK_ENTRY: 'truck_entry',
}

export enum ERP_TYPE {
  QBO = 'qbo',
  MBC = 'mbc',
  QBD = 'qbd',
  NETSUITE = 'netsuite',
}

export const ERP_PROVIDERS = {
  [ERP_TYPE.QBO]: {
    name: 'QuickBooks Online',
  },
  [ERP_TYPE.MBC]: {
    name: 'Microsoft Business Central',
  },
  [ERP_TYPE.QBD]: {
    name: 'QuickBooks Desktop',
  },
  [ERP_TYPE.NETSUITE]: {
    name: 'Netsuite',
  },
}

export const PRECISION_OPTIONS = [
  { id: 1, name: 1 },
  { id: 2, name: 2 },
  { id: 3, name: 3 },
  { id: 4, name: 4 },
]

export const COMMODITY_TYPE = [
  { id: 'FERROUS', name: 'Ferrous' },
  { id: 'NON_FERROUS', name: 'Non-Ferrous' },
  { id: 'OTHER', name: 'Other' },
]

export const COMMODITY_CLASS = {
  FERROUS: 'FERROUS',
  NON_FERROUS: 'NON_FERROUS',
  OTHER: 'OTHER',
}

export const DEFAULT_PRECISION = 4

export const ACTIVITY_TYPE_OPTIONS = [
  { id: 'deposit', name: 'Deposit' },
  { id: 'withdrawal', name: 'Withdrawal' },
  { id: 'transfer', name: 'Transfer' },
]

export const ACTIVITY_TYPE_VALUES = {
  deposit: 'Deposit',
  withdrawal: 'Withdrawal',
}

export const PRINT_DIALOG_TYPES = {
  COMMON: {
    key: 'common',
    layoutWidth: '100%',
    maxWidth: 990,
    logoHeight: '60px',
    fontSize: '14px',
    lineHeight: '1.5',
    paperSize: 'unset',
    paperMargin: '0',
  },
  RECEIPT: {
    key: 'receipt',
    layoutWidth: '100%',
    maxWidth: 736,
    logoHeight: '80px',
    fontSize: '14px',
    lineHeight: '20px',
    paperSize: '736px 1218px',
    paperMargin: '0.5cm',
  },
  CHECK: {
    key: 'check',
    layoutWidth: '100%',
    maxWidth: 816,
    paperMargin: '0',
  },
  TAG: {
    key: 'tag',
    maxWidth: 990,
    layoutWidth: '820px',
    paperSize: '4in 6in',
    paperMargin: '0',
    logoHeight: '28px',
    lineHeight: '12px',
  },
  PULL_APART_TAG: {
    key: 'tag',
    maxWidth: 990,
    layoutWidth: '100%',
    logoHeight: '28px',
    lineHeight: '12px',
    paperMargin: '0',
  },
}

export const CHURN_ZERO_EVENTS = {
  LOG_IN: 'Log In',
  LOG_OUT: 'Log Out',

  CREATE_INBOUND_TICKET: 'Create Inbound Ticket',
  UPDATE_INBOUND_TICKET: 'Edit Inbound Ticket',
  PAY_INBOUND_TICKET: 'Pay Inbound Ticket',
  REVERSE_INBOUND_TICKET_PAYMENT: 'Reverse Inbound Ticket Payment',
  VOID_IBT: 'Void Inbound Ticket',
  SAVE_PRINT: 'Save and Print Inbound Ticket',
  SAVE_PAY: 'Save and Pay Inbound Ticket',
  SAVE_ONLY: 'Save Inbound Ticket',
  SAVE_INVOICE: 'Save and Generate Inbound Ticket Invoice',
  VIEW_INVOICE: 'View Inbound Ticket Invoice',

  CREATE_OUTBOUND_TICKET: 'Create Outbound Ticket',
  UPDATE_OUTBOUND_TICKET: 'Edit Outbound Ticket',

  CREATE_PAYMENT: 'Create Payment',
  UPDATE_PAYMENT: 'Edit Payment',
  CONFIRM_NEW_PAYMENT: 'Confirm New Payment',
  CONFIRM_EXISTING_PAYMENT: 'Confirm Existing Payment',
  REVERSE_PAYMENT: 'Reverse Payment',
  CREATE_INVOICE: 'Create Invoice',
  UPDATE_INVOICE: 'Edit Invoice',
  VOID_INVOICE: 'Void Invoice',

  CREATE_PURCHASE_ORDER: 'Create Purchase Orders',
  UPDATE_PURCHASE_ORDER: 'Edit Purchase Orders',
  DOWNLOAD_PURCHASE_ORDER: 'Download Purchase Order',
  DUPLICATE_PURCHASE_ORDER: 'Duplicate Purchase Order',
  EMAIL_PURCHASE_ORDER: 'Email Purchase Order',
  PRINT_PURCHASE_ORDER: 'Print Purchase Order',

  CREATE_SALES_ORDER: 'Create Sales Orders',
  UPDATE_SALES_ORDER: 'Edit Sales Orders',
  DOWNLOAD_SALES_ORDER: 'Download Sales Order',
  DUPLICATE_SALES_ORDER: 'Duplicate Sales Order',
  EMAIL_SALES_ORDER: 'Email Sales Order',
  PRINT_SALES_ORDER: 'Print Sales Order',

  REGRADE_MATERIALS: 'Regrade Materials',
  CREATE_REGRADE: 'Create Regrade',
  UPDATE_REGRADE: 'Update Regrade',
  VOID_REGRADE: 'Void Regrade',

  CREATE_FINISHED_GOOD: 'Create New Finished Goods',
  UPDATE_FINISHED_GOOD: 'Update Finished Goods',
  CREATE_PACKING_LIST: 'Create Packing Lists',

  INVENTORY_ADJUSTMENTS: 'Inventory Adjustments',
  CREATE_ADJUSTMENT: 'Create Adjustments',
  UPDATE_ADJUSTMENT: 'Update Adjustments',
  VOID_ADJUSTMENT: 'Void Adjustments',

  PRINT_BALE_TAGS: 'Print Bale Tags',

  CREATE_CUSTOMER: 'Create Customers',
  UPDATE_CUSTOMER: 'Edit Customers',
  ARCHIVE_CUSTOMER: 'Archive Customer',

  CREATE_CARRIER: 'Create Carrier',
  UPDATE_CARRIER: 'Edit Carrier',
  ARCHIVE_CARRIER: 'Archive Carrier',

  ADD_MATERIAL: 'Add Materials',
  UPDATE_MATERIAL: 'Update Material',
  ARCHIVE_MATERIAL: 'Archive Material',

  ADJUST_SETTINGS: 'Adjust Settings',
  UPDATE_MATERIAL_PRICES: 'Edit Material Prices',

  UPDATE_PRICE_LIST: 'Edit Price List',
  UPDATE_PRICING_FORMULA: 'Edit Pricing Formula',
  USE_DEFAULT_PRICE: 'Use Default Price',
  UPLOAD_CSV: 'Upload CSV',
  DOWNLOAD_CSV: 'Download CSV',
  UPLOAD_PRICE_SHEET_CSV: 'Upload Price Sheet CSV',
  DOWNLOAD_PRICE_SHEET_CSV: 'Download Price Sheet CSV',

  VIEW_ANALYTICS: 'View Analytics',
  VIEW_REPORTS: 'View Reports',
  MERGE_TICKETS: 'Merge Tickets',

  DOWNLOAD_XML: 'Donwload XML',

  CHANGE_UM: 'Change UM',

  CREATE_CONTAINER: 'Create Container',
  PATCH_CONTAINER: 'Edit Container',
  CREATE_TRUCK: 'Create Truck',
  PATCH_TRUCK: 'Edit Truck',
  CREATE_TRAILER: 'Create Trailer',
  PATCH_TRAILER: 'Edit Trailer',

  UPDATE_DRIVER: 'Update Driver',

  CREATE_DISPATCH_TICKET: 'Create Dispatch Ticket',
  PATCH_DISPATCH_TICKET: 'Patch Dispatch Ticket',
  GET_S3_IMAGE: 'Get S3 Image',

  CREATE_PAYMENT_TERM: 'Create Payment Term',
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  // viewPurchasesAndSalesTabs: 'View Purchases And Sales Tabs',
  // ListViewLoadTimes: 'List View Load Times',
  // syncPaymentsToLedger: '',
  // downloadReports: '',
  // adjustAdminSettings: '',
  // useHelpCenterAndChatBot: '',
  ARCHIVE_SALES_ORDER: 'Archive Sales Order',
  ARCHIVE_PURCHASE_ORDER: 'Archive Purchase Order',
  CAPTURE_IMAGE: 'Capture Image',
}

export const CUSTOMERS_FILTERS = {
  CONSUMER: { type: 'Consumer' },
  SUPPLIER: { type: 'Supplier' },
  CARRIER: { type: 'Carrier' },
  YARD: { type: 'Yard' },
  SHOW_ARCHIVE: { type: 'showArchived' },
}

export const DECIMAL_PRECISION_PRESETS = {
  WEIGHT: {
    decimalPrecisionOverride: 2,
    removeTrailingZeros: true,
  },
}

export const SORTABLE_IBT_FIELDS = {
  TICKET_ID: 'ticketId',
  EFFECTIVE_DATE: 'effectiveDate',
  CUSTOMER_DISPLAY_NAME: 'customerDisplayName',
  NET_WEIGHT: 'netWeight',
  TOTAL_VALUE: 'netCost',
}

export const SORTABLE_OBT_FIELDS = {
  TICKET_ID: 'ticketId',
  CUSTOMER_DISPLAY_NAME: 'customerDisplayName',
  EFFECTIVE_DATE: 'effectiveDate',
  SALES_ORDER_TICKET_ID: 'salesOrderTicketId',
}

export const SORTABLE_INVOICE_PAYMENTS_FIELDS = {
  PAYMENT_DATE: 'paymentDate',
}

export const SORTABLE_CUSTOMER_FIELDS = {
  DISPLAY_NAME: 'displayName',
  TYPE: 'type',
  VENDOR_CLASS: 'vendorClass',
}

export const SORTABLE_BILL_FIELDS = {
  EXTERNAL_ID: 'externalId',
  STATUS: 'status',
  CUSTOMER_DISPLAY_NAME: 'customerDisplayName',
  LAST_UPDATED: 'updatedAt',
  NUMBER_OF_TICKETS: 'numberOfTickets',
}

export const SORTABLE_BATCH_BILL_FIELDS = {
  EXTERNAL_ID: 'externalId',
  LAST_UPDATED: 'updatedAt',
}

export const SORTABLE_INVOICE_FIELDS = {
  INVOICE_TICKET_ID: 'ticketId',
  STATUS: 'status',
  CUSTOMER_DISPLAY_NAME: 'customerDisplayName',
  SALES_ORDER_TICKET_ID: 'salesOrderTicketId',
  TOTAL: 'total',
  ISSUE_DATE: 'issueDate',
  DUE_DATE: 'dueDate',
}

export const SORTABLE_FINISHED_GOOD_FIELDS = {
  TAG: 'tag',
  PO_NUMBER: 'purchaseOrderNumber',
  CREATED_AT: 'createdAt',
  EFFECTIVE_DATE: 'effectiveDate',
  COMMODITY: 'commodity',
  MATERIAL_TYPE: 'materialType',
  TYPE: 'type',
  NET_WEIGHT: 'netWeight',
  STATUS: 'status',
}

export const SORTABLE_ASSET_HISTORY_FIELDS = {
  LAST_UPDATED: 'lastUpdated',
}

export const SORTABLE_DISPATCH_TICKET_HISTORY_FIELDS = {
  DATE_SCHEDULED: 'scheduleDate',
  EXTERNAL_ID: 'externalId',
  STATUS: 'status',
  TYPE: 'type',
  CUSTOMER: 'customer',
  LOCATION: 'location',
  DRIVER: 'driver',
  CREATED_AT: 'createdAt',
}

export const SORTABLE_PURCHASE_PRICE_HISTORY_FIELDS = {
  EFFECTIVE_DATE: 'date',
  PRICE: 'price',
}

export const SORTABLE_FREIGHT_BILL_FIELDS = {
  TICKET_NUMBER: 'ticketNumber',
  CARRIER_NAME: 'carrierName',
}

export const PAYMENT_ROUNDING_OPTIONS = [
  { id: '0', name: 'Do not round' },
  { id: '0.05', name: '0.05' },
  { id: '0.1', name: '0.1' },
  { id: '0.25', name: '0.25' },
  { id: '0.5', name: '0.5' },
  { id: '1', name: '1' },
]

// 0 0.05 0.1 0.25 0.5 1
export enum PAYMENT_ROUNDING {
  ZERO = '0',
  POINT_ZERO_FIVE = '0.05',
  POINT_ONE = '0.1',
  POINT_TWO_FIVE = '0.25',
  POINT_FIVE = '0.5',
  ONE = '1',
}

/** This defines the direction of the rounding operation */
export enum PAYMENT_ROUNDING_DIRECTION {
  NEAREST = 'NEAREST',

  /** This is really round away from zero. We use the term round up to keep it simple to the user */
  UP = 'UP',

  /** This is really round towards zero. We use the term round down to keep it simple to the user */
  DOWN = 'DOWN',
}

export const PAYMENT_ROUNDING_DIRECTION_OPTIONS = [
  { id: PAYMENT_ROUNDING_DIRECTION.NEAREST, name: 'Nearest' },
  { id: PAYMENT_ROUNDING_DIRECTION.UP, name: 'Round Up' },
  { id: PAYMENT_ROUNDING_DIRECTION.DOWN, name: 'Round Down' },
]

export const MODAL_VIEW_MODES = {
  NEW: 'NEW',
  VIEW: 'VIEW',
  EDIT: 'EDIT',
}

export const ERP_SYNC_STATUSES = {
  COMPLETED_BY_SYSTEM: 'COMPLETED_BY_SYSTEM',
  FAILED: 'FAILED',
}

export const CONSUMER_INFO_FIELDS = [
  [
    {
      name: 'customer',
      label: 'Consumer Name',
      dataTest: 'customer',
      fieldType: 'static',
    },
    {
      name: 'customerPONumber',
      label: 'Customer PO#',
      dataTest: 'customer-po-number',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'salesOrderLocationId',
      label: 'Location',
      dataTest: 'sales-order-location-id',
      fieldType: 'static',
    },
    {
      name: 'millDeliveryNumber',
      label: 'Mill Delivery #',
      dataTest: 'mill-delivery-number',
      fieldType: 'static',
    },
  ],
]

export const SUPPLIER_INFO_FIELDS = [
  [
    {
      name: 'supplier',
      label: 'Supplier Name',
      dataTest: 'supplier',
      fieldType: 'static',
    },
    {
      name: 'customerSONumber',
      label: 'Customer SO#',
      dataTest: 'customer-so-number',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'purchaseOrderLocationId',
      label: 'Location',
      dataTest: 'purchase-order-location-id',
      fieldType: 'static',
    },
  ],
]

export const salesOrderDetailFields = [
  [
    {
      name: 'orderSalesDetails.effectiveDate',
      label: 'Effective Date',
      dataTest: 'order-sales-details-effective-date',
      fieldType: 'static',
    },
    {
      name: 'orderSalesDetails.expirationDate',
      label: 'Expiration Date',
      dataTest: 'order-sales-details-expiration-date',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'orderSalesDetails.packageType',
      label: 'Package Type',
      dataTest: 'order-sales-details-package-type',
      fieldType: 'static',
    },
    {
      name: 'orderSalesDetails.fairOnBoard',
      label: 'F.O.B.',
      dataTest: 'order-sales-details-fair-on-board',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'orderSalesDetails.departingYard',
      label: 'Departing Yard',
      dataTest: 'order-sales-details-departing-yard',
      fieldType: 'static',
    },
    {
      name: 'orderSalesDetails.invoiceWeights',
      label: 'Invoice Weights',
      dataTest: 'order-sales-details-invoice-weights',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'isExport',
      label: 'Export',
      dataTest: 'order-sales-details-export',
      fieldType: 'static',
    },
  ],
]

export const purchaseOrderDetailFields = [
  [
    {
      name: 'order.effectiveDate',
      label: 'Effective Date',
      dataTest: 'order-effective-date',
      fieldType: 'static',
    },
    {
      name: 'order.expirationDate',
      label: 'Expiration Date',
      dataTest: 'order-expiration-date',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'order.packageType',
      label: 'Package Type',
      dataTest: 'order-package-type',
      fieldType: 'static',
    },
    {
      name: 'order.pickupDelivery',
      label: 'Pickup/Delivery?',
      dataTest: 'order-pickup-delivery',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'order.receivingYard',
      label: 'Receiving Yard',
      dataTest: 'order-receiving-yard',
      fieldType: 'static',
    },
  ],
]

export const paymentInfoFields = [
  [
    {
      name: 'paymentTermId',
      label: 'Payment Terms',
      dataTest: 'payment-term',
      fieldType: 'static',
    },
    {
      name: 'paymentMethod',
      label: 'Payment Method',
      dataTest: 'payment-method',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'currency',
      label: 'Currency',
      dataTest: 'currency',
      fieldType: 'static',
    },
    {
      name: 'paymentOptions',
      label: 'Payment Options',
      dataTest: 'payment-options',
      fieldType: 'static',
    },
  ],
  [
    {
      name: 'foreignExchangeRate',
      label: 'Custom FX Rate',
      dataTest: 'custom-foreign-exchange-rate',
      fieldType: 'static',
      inputProps: {
        step: '0.0001',
        min: '0',
        precision: 4,
      },
    },
  ],
]

export const DEFAULT_SUPPLIER_TYPE_VENDOR_CLASS_IDS = [
  '00000000-0000-0000-0000-000000000000',
  '10000000-0000-0000-0000-000000000000',
  '20000000-0000-0000-0000-000000000000',
  '30000000-0000-0000-0000-000000000000',
]

const ZERO_UUID = '00000000-0000-0000-0000-000000000000'
export const RETAIL_SUPPLIER_TYPE_ID = ZERO_UUID

export const TICKET_TYPES = {
  TRANSFER: 'TRANSFER',
}

export enum TICKET_SOURCE_TYPE {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export const INVOICE_WEIGHT_MODES = {
  YARD: 'YARD',
  CONSUMER: 'CONSUMER',
}

export const TRANSPORTATION_TYPE_OPTIONS = [
  { id: 'RAIL', name: 'Rail' },
  { id: 'TRUCK', name: 'Truck' },
  { id: 'BARGE', name: 'Barge' },
  { id: 'OTHER', name: 'Other' },
]

export const FILTER_OPTION_TYPES = {
  CUSTOMER_AUTOCOMPLETE: 'CUSTOMER_AUTOCOMPLETE',
  SELECT: 'SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
}

export const THRESHOLD_UM_OPTIONS = [
  { id: 'pounds', name: 'lbs' },
  { id: 'percentage', name: '%' },
]

export const FREIGHT_LANE_DATE_TYPES = {
  EXPIRATION: 'EXPIRATION',
  EFFECTIVE: 'EFFECTIVE',
}

export const PRINT_DOCUMENT_TYPES = {
  BILL: 'BILL',
  INVOICE: 'INVOICE',
}

export const BILL_TYPES = {
  MATERIAL: {
    id: 'MATERIAL',
    name: 'Material',
  },
  FREIGHT: {
    id: 'FREIGHT',
    name: 'Freight',
  },
}

export const CAR_COLORS = [
  'AMETHYST',
  'BEIGE',
  'BLACK',
  'BLUE',
  'BROWN',
  'BRONZE',
  'CAMOUFLAGE',
  'CHROME',
  'COPPER',
  'CREAM',
  'DARK BLUE',
  'DARK GREEN',
  'GOLD',
  'GREEN',
  'GRAY',
  'LAVENDER',
  'LIGHT BLUE',
  'LIGHT GREEN',
  'MAROON',
  'BURGUNDY',
  'MULTICOLORED',
  'MAUVE',
  'ORANGE',
  'PURPLE',
  'RED',
  'SILVER',
  'TAN',
  'TEAL',
  'TAUPE',
  'TURQUOISE',
  'WHITE',
  'YELLOW',
]

export const CAR_BODY_TYPES = [
  'SEDAN',
  'COUPE',
  'SPORTS CAR',
  'STATION WAGON',
  'HATCHBACK',
  'CONVERTIBLE',
  'SPORT-UTILITY VEHICLE (SUV)',
  'MINIVAN',
  'PICKUP',
  'MULTI AXEL TRUCK',
]

export const IMAGE_TYPES = {
  GROSS: 'gross',
  TARE: 'tare',
}

export enum DT_STATUS_ENUM {
  REQUESTED = 'REQUESTED',
  UNASSIGNED = 'UNASSIGNED',
  ASSIGNED = 'ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  VOID = 'VOID',
}

export const DISPATCH_TICKET_STATUSES = {
  [DT_STATUS_ENUM.REQUESTED]: {
    id: 'REQUESTED',
    name: 'Requested',
    icon: <HelpIcon />,
    index: 0,
  },
  [DT_STATUS_ENUM.UNASSIGNED]: {
    id: 'UNASSIGNED',
    name: 'Unassigned',
    icon: <PersonOutlineOutlinedIcon />,
    index: 1,
  },
  [DT_STATUS_ENUM.ASSIGNED]: {
    id: 'ASSIGNED',
    name: 'Assigned',
    icon: <PersonIcon />,
    index: 2,
  },
  [DT_STATUS_ENUM.IN_PROGRESS]: {
    id: 'IN_PROGRESS',
    name: 'In-Progress',
    icon: <TimelapseIcon />,
    color: 'info',
    index: 3,
  },
  [DT_STATUS_ENUM.COMPLETED]: {
    id: 'COMPLETED',
    name: 'Completed',
    icon: <CheckCircleIcon />,
    color: 'success',
    index: 4,
  },
  [DT_STATUS_ENUM.FAILED]: {
    id: 'FAILED',
    name: 'Failed',
    icon: <ErrorIcon />,
    color: 'error',
    index: 5,
  },
  [DT_STATUS_ENUM.VOID]: {
    id: 'VOID',
    name: 'Void',
    icon: <DeleteForeverIcon />,
    color: 'error',
    index: 6,
  },
}
export const DISPATCH_TICKET_STATUSES_ARRAY = Object.values(DISPATCH_TICKET_STATUSES)
  .map(value => ({ ...value, label: value?.name }))
  .sort((a, b) => a.index - b.index)

// Define the TypeScript Enum
export enum DISPATCH_TICKET_ENUM {
  EXCHANGE = 'EXCHANGE',
  DROP_OFF = 'DROP_OFF',
  PICK_UP = 'PICK_UP',
  PICK_AND_RETURN = 'PICK_AND_RETURN',
  DELIVERY = 'DELIVERY',
  LIVE_LOAD = 'LIVE_LOAD',
}

export const DISPATCH_TICKET_TYPES = {
  [DISPATCH_TICKET_ENUM.EXCHANGE]: {
    id: 'EXCHANGE',
    name: 'Exchange',
    spacedName: 'Exchange',
    index: 0,
  },
  [DISPATCH_TICKET_ENUM.DROP_OFF]: {
    id: 'DROP_OFF',
    name: 'Dropoff',
    spacedName: 'Drop Off',
    index: 1,
  },
  [DISPATCH_TICKET_ENUM.PICK_UP]: {
    id: 'PICK_UP',
    name: 'Pickup',
    spacedName: 'Pick Up',
    index: 2,
  },
  [DISPATCH_TICKET_ENUM.PICK_AND_RETURN]: {
    id: 'PICK_AND_RETURN',
    name: 'Pick And Return',
    spacedName: 'Pick And Return',
    index: 3,
  },
  [DISPATCH_TICKET_ENUM.DELIVERY]: {
    id: 'DELIVERY',
    name: 'Delivery',
    spacedName: 'Delivery',
    index: 4,
  },
  [DISPATCH_TICKET_ENUM.LIVE_LOAD]: {
    id: 'LIVE_LOAD',
    name: 'Live Load',
    spacedName: 'Live Load',
    index: 5,
  },
}

export const DISPATCH_TICKET_TYPES_ARRAY = Object.values(DISPATCH_TICKET_TYPES)
  .map(value => ({ ...value, label: value?.name }))
  .sort((a, b) => a.index - b.index)

export enum DISPATCH_TICKET_EXCLUDE_LINKED_FILTER {
  IBT = 'ibt',
  OBT = 'obt',
}

export const RECURRING_DISPATCH_TICKET_DROPDOWN_OPTIONS = {
  DAILY: {
    id: 'DAILY',
    name: 'Daily',
  },
  WEEKLY: {
    id: 'WEEKLY',
    name: 'Weekly',
  },
  MONTHLY: {
    id: 'MONTHLY',
    name: 'Monthly',
  },
  CUSTOM: {
    id: 'CUSTOM',
    name: 'Custom',
  },
  NONE: {
    id: 'NONE',
    name: 'None',
  },
}

export enum WEEKDAY_ENUM {
  MONDAY = 'MO',
  TUESDAY = 'TU',
  WEDNESDAY = 'WE',
  THURSDAY = 'TH',
  FRIDAY = 'FR',
  SATURDAY = 'SA',
  SUNDAY = 'SU',
}

export const WEEKDAY_MAP = {
  0: WEEKDAY_ENUM.SUNDAY,
  1: WEEKDAY_ENUM.MONDAY,
  2: WEEKDAY_ENUM.TUESDAY,
  3: WEEKDAY_ENUM.WEDNESDAY,
  4: WEEKDAY_ENUM.THURSDAY,
  5: WEEKDAY_ENUM.FRIDAY,
  6: WEEKDAY_ENUM.SATURDAY,
}

// These come from PriceSheetCsvUploadErrors, which is defined in the backend
export const PriceSheetCsvUploadErrors = {
  InvalidFileFormat: 'Invalid file format',
  InvalidHeader: 'Invalid header',
  InvalidColumnPrice: 'Invalid price',
  InvalidColumnMinMaxRange: 'Invalid min/max range',
  EntryNotFound: 'Price entry not found',
  FileTooLarge: 'File too large',
}

export const DATE_RANGE_OPTIONS = {
  TODAY: 'Today',
  PAST_7_DAYS: 'Past 7 Days',
  PAST_30_DAYS: 'Past 30 Days',
  ALL_TIME: 'All Time',
}

export const ASSET_STATUSES = {
  DEPLOYED: {
    id: 'DEPLOYED',
    name: 'Deployed',
  },
  IN_PROGRESS: {
    id: 'IN_PROGRESS',
    name: 'In-Progress',
  },
  INVENTORY: {
    id: 'INVENTORY',
    name: 'Inventory',
  },
  FAILED: {
    id: 'FAILED',
    name: 'Failed',
  },
}

export enum ASSET_CATEGORY {
  CONTAINER = 'CONTAINER',
  TRUCK = 'TRUCK',
  TRAILER = 'TRAILER',
}

export const WASTE_CODE = 'WASTE'

export const ORG_MODE_ROUTES = ['Load Board', 'Assets', 'Reports']

export const ORG_MODE_COMPATIBLE_APIS = [
  '/core-api/core/organization',
  '/dispatch-api/core/dispatch-tickets',
  '/dispatch-api/core/drivers',
]

/**
 * This is currently not being used. It will be used when the load board includes
 * tickets with past scheduledDate's
 */
export const LOAD_BOARD_ITEM_DATE_ICONS = {
  OLDER: (
    <NotificationImportantIcon
      style={{
        color: 'red',
        fontSize: 20,
      }}
    />
  ),
  YESTERDAY: (
    <NotificationImportantIcon
      style={{
        color: 'orange',
        fontSize: 20,
      }}
    />
  ),
  TODAY: <></>,
}

export const CUSTOM_CHECK_TEMPLATE_FIELDS = [
  {
    id: 'paymentDate',
    textAlignment: 'right',
    title: 'Date',
  },
  {
    id: 'checkRecipient',
    textAlignment: 'left',
    title: 'Payee Name',
  },
  {
    id: 'amount',
    textAlignment: 'right',
    title: 'Numerical Amount',
  },
  {
    id: 'textAmount',
    textAlignment: 'left',
    title: 'Amount Spelled Out',
  },
  {
    id: 'customerAddress',
    textAlignment: 'left',
    title: 'Payee Address',
  },
  {
    id: 'memo',
    textAlignment: 'left',
    title: 'Memo',
  },
  {
    id: 'checkSignature',
    textAlignment: 'left',
    title: 'Signature',
  },
]

export const PAGE_SIZE = 30

export enum EMPLOYMENT_STATUS {
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  RETIRED = 'RETIRED',
  EMPLOYED = 'EMPLOYED',
}

export const NUMBER_OF_AXLES_OPTIONS = [
  { id: 1, name: 'OFF' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' },
]

export const DEFAULT_AXLE_DATA = {
  axleNumber: 1,
  gross: 0,
  isManualGross: false,
  grossImages: [],
  tare: 0,
  isManualTare: false,
  tareImages: [],
}

export enum ROUNDING_PRECISIONS {
  WEIGHT = 1,
  COST = 2,
  PRICE = 4,
  INTERNAL = 15,
}

export enum GS_ERROR_CODE {
  'VALIDATION_ERROR' = 'VALIDATION_ERROR',
  'CONCURRENCY_VIOLATION' = 'CONCURRENCY_VIOLATION',
}

export const LOCK_ENTITY_MAPPER = {
  INBOUND_TICKET: {
    id: 'INBOUND_TICKET',
    name: 'Inbound Ticket',
    baseUrl: '/app/purchases/ticket-library/',
    statuses: TICKET_STATUSES,
  },
  OUTBOUND_TICKET: {
    id: 'OUTBOUND_TICKET',
    name: 'Outbound Ticket',
    baseUrl: '/app/sales/outbound-tickets/',
    statuses: OUTBOUND_TICKET_STATUSES,
  },
  BILL: {
    id: 'BILL',
    name: 'Bill',
    baseUrl: '/app/purchases/bills/',
    statuses: BILL_STATUSES,
  },
  INVOICE: {
    id: 'INVOICE',
    name: 'Invoice',
    baseUrl: '/app/sales/invoices/',
    statuses: INVOICE_STATUSES,
  },
}

export const ENTITY_IN_LOCK_PERIOD_MESSAGE =
  'This action cannot be completed because it affects a locked period. In order to complete this action, you must go to settings and “unlock” the relevant financial period'

export enum GS_ROLE {
  DRIVER = 'driver',
  PORTAL_USER = 'portalUser',
  SCALE_OPERATOR = 'scaleOperator',
  YARD_ADMIN = 'yardAdmin',
  YARD_EMPLOYEE = 'yardEmployee',
  YARD_MANAGER = 'yardManager',
}

export const GS_ROLE_INFO = {
  [GS_ROLE.YARD_EMPLOYEE]: {
    id: GS_ROLE.YARD_EMPLOYEE,
    name: 'Yard Employee',
  },
  [GS_ROLE.SCALE_OPERATOR]: {
    id: GS_ROLE.SCALE_OPERATOR,
    name: 'Scale Operator',
  },
  [GS_ROLE.PORTAL_USER]: {
    id: GS_ROLE.PORTAL_USER,
    name: 'Portal User',
  },
  [GS_ROLE.YARD_MANAGER]: {
    id: GS_ROLE.YARD_MANAGER,
    name: 'Yard Manager',
  },
  [GS_ROLE.YARD_ADMIN]: {
    id: GS_ROLE.YARD_ADMIN,
    name: 'Yard Admin',
  },
  [GS_ROLE.DRIVER]: {
    id: GS_ROLE.DRIVER,
    name: 'Driver',
  },
}

export enum COMMODITY_RULE_TYPES {
  WEIGHT_THRESHOLD = 'WEIGHT_THRESHOLD',
}

export enum CONTRACT_WARNING_SETTING {
  OFF = 'off',
  FULFILLMENT_WARNING = 'fulfillmentWarning',
  EXPIRATION_WARNING = 'expirationWarning',
}

export enum AUTO_CLOSE_SETTING {
  OFF = 'off',
  CLOSE_ON_FULFILLMENT = 'closeOnFulfillment',
  CLOSE_ON_EXPIRATION = 'closeOnExpiration',
  WARN_ON_FULFILLMENT = 'warnOnFulfillment',
  WARN_ON_EXPIRATION = 'warnOnExpiration',
}

export const AUTO_CLOSE_CONTRACT_OPTIONS = [
  { id: AUTO_CLOSE_SETTING.OFF, name: 'Off' },
  { id: AUTO_CLOSE_SETTING.CLOSE_ON_FULFILLMENT, name: 'Close on contract fulfillment' },
  { id: AUTO_CLOSE_SETTING.CLOSE_ON_EXPIRATION, name: 'Close on expiration date' },
  { id: AUTO_CLOSE_SETTING.WARN_ON_FULFILLMENT, name: 'Warn on contract fulfillment' },
  { id: AUTO_CLOSE_SETTING.WARN_ON_EXPIRATION, name: 'Warn on expiration date' },
]

export const COMMODITY_WEIGHT_THRESHOLD_ALERT_MESSAGE =
  'This action cannot be completed because the weight threshold for one or more commodities have been exceeded.'

export const COMMODITY_TYPE_COST_THRESHOLD_ALERT_MESSAGE =
  'This action cannot be completed because the cost threshold for one or more commodity types have been exceeded.'

export const DEFAULT_PDF_WIDTH = '216mm'

export enum PDF_TYPE {
  IBT_PURCHASE_TICKET = 'IBT_PURCHASE_TICKET',
  IBT_SCALE_TICKET = 'IBT_SCALE_TICKET',
  BILL_SETTLEMENT_DOC = 'BILL_SETTLEMENT_DOC',
  OBT_PACKING_LIST = 'OBT_PACKING_LIST',
  OBT_BILL_OF_LADING = 'OBT_BILL_OF_LADING',
  INVOICE = 'INVOICE',
  CHECK = 'CHECK',
}

export enum EMAIL_TYPE {
  OBT_PACKING_LIST = 'OBT_PACKING_LIST',
  OBT_BILL_OF_LADING = 'OBT_BILL_OF_LADING',
  OBT_PL_AND_BOL = 'OBT_PL_AND_BOL',
}

export enum LOCALE {
  enUS = 'en-US',
  enCA = 'en-CA',
  enNZ = 'en-NZ',
}

// any new locales will also need to be added to DAY_JS_LOCALE_IMPORTS in `utils/importLocaleForDayjs.ts`
export const LOCALE_MAP = {
  [LOCALE.enUS]: {
    report: 'en-US',
    dayjs: 'en',
  },
  [LOCALE.enCA]: {
    report: 'en-US', // explo doesn't support en-CA
    dayjs: 'en',
  },
  [LOCALE.enNZ]: {
    report: 'en-GB', // explo doesn't support en-NZ
    dayjs: 'en-nz',
  },
}
